import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const signIn = createAsyncThunk(
  "user/signIn",
  async ({ email, password, enqueueSnackbar }, { dispatch }) => {
    try {
      const { user } = await auth.signInWithEmailAndPassword(email, password);
      dispatch(setUser({ email: user.email, enqueueSnackbar }));

      return {};
    } catch (error) {
      enqueueSnackbar("Usuario o contraseña incorrectos", { variant: "error" });
      return error;
    }
  }
);

export const signOut = createAsyncThunk("user/singOut", async () => {
  await auth.signOut();
});

export const setUser = createAsyncThunk(
  "user/setData",
  async ({ email, enqueueSnackbar }, { dispatch }) => {
    const { docs } = await app
      .firestore()
      .collection("usuarios")
      .where("Correo", "==", email)
      .get();
    const data = { ...docs[0].data(), id: docs[0].id };
    const roles = data.Roles;
    if (
      !roles?.superAdministrador &&
      !roles?.administrador &&
      !roles?.supervisor
    ) {
      enqueueSnackbar("¡No tienes permisos para acceder!", {
        variant: "error",
      });
      return Error("Not permissions");
    }

    const complexs =
      data.ConjuntoUid?.map((conjunto) => JSON.parse(conjunto)) || [];
    const idcomplex = complexs[0]?.uid || data.ConjuntoUidResidencia;


    return {
      id: data.id,
      name: data.Nombre,
      lastName: data.Apellido,
      email: data.Correo,
      phone: data.Telefono,
      identity: data.Cedula,
      roles: data.Roles,
      complexs,
      ConjuntoUidResidencia: data.ConjuntoUidResidencia,
    };
  }
);

export const authSlice = createSlice({
  name: "user",
  initialState: {
    isLoading: false,
    isAuth: false,
    error: "",
    user: {},
  }
});
export const selectUser = (state) => state.auth.user;
export default authSlice.reducer;
